import ProductController from "./ProductController";

export default ProductController;
